import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular/main';
import { ICellRendererParams, GridRow } from 'ag-grid-community/main';
import { Params } from '@angular/router';
import { UrlBuilder } from '../../../core';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { Observable } from 'rxjs';

@Component({
    selector: 'container-renderer',
    template: '<a [routerLink]="" (click)="navigate()">{{value}}-{{containerValue}}</a>',
    styles: [require('./column-renderer.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContainerRendererComponent implements AgFrameworkComponent<ICellRendererParams> {
    public value: string;
    public sampleData: any;
    public containerValue: string;

    constructor(
        private urlBuilder: UrlBuilder,
        private storage: SampleTrackingStorage
    ) { }

    public agInit(row: ICellRendererParams): void {
        if (!row.value && !row.data) { return; }

        this.value = row.data.accessionNumber;
        this.containerValue = row.data.containerNumber;
        if (!this.containerValue && !this.value) { return; }

        this.sampleData = { accessionNumber: this.value, containerNumber: this.containerValue };

    }

    public navigate() {
        if (!this.sampleData) { return; }
        this.storage.sampleSearchData = new Observable(ob => ob.next(this.sampleData));
        this.urlBuilder.esa().sampletracking().sampleDetails(this.sampleData.containerNumber).navigate();
        return;
    }

}